import * as Sentry from '@sentry/react'

export function initSentry() {
  // Only initialize Sentry in production
  if (import.meta.env.PROD) {
    const dsn = import.meta.env.VITE_SENTRY_DSN

    // Skip initialization if DSN is not configured
    if (!dsn) {
      console.warn('[Sentry] DSN not configured, skipping initialization')
      return
    }

    Sentry.init({
      dsn,
      environment: import.meta.env.VITE_ENV || 'production',
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: true,
        }),
      ],
      // Performance Monitoring
      tracesSampleRate: 0.1, // Capture 10% of transactions

      // Session Replay
      replaysSessionSampleRate: 0.1, // Sample 10% of sessions
      replaysOnErrorSampleRate: 1.0, // Sample 100% of sessions with errors

      // Filter out non-critical errors
      beforeSend(event, hint) {
        const error = hint.originalException

        // Filter out ResizeObserver errors (browser quirk, not actionable)
        if (error instanceof Error && error.message.includes('ResizeObserver')) {
          return null
        }

        // Filter out network errors from ad blockers
        if (error instanceof Error && error.message.includes('blocked by client')) {
          return null
        }

        return event
      },
    })
  }
}
